<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="Copyright">Copyright© Seaforth Publishing 2011<br/><br/>
Colour profiles and line drawings © George Richardson 2011</a></p><a id="Copyright">
</a><p class="copyright3"><a id="Copyright">First published in Great Britain in 2010 by Seaforth Publishing,<br/>
an imprint of Pen &amp; Sword Books Ltd, 47 Church Street, Barnsley,<br/>
S Yorkshire S70 2AS<br/>
</a><a href="http://www.seaforthpublishing.com" target="_blank">www.seaforthpublishing.com</a></p>
<p class="copyright3">and in the United States of America by Classic Warships<br/>
Publishing, PO Box 57591, Tucson, Arizona 85732<br/>
<a href="http://www.classicwarships.com" target="_blank">www.classicwarships.com</a></p>
<p class="copyright3"><i>British Library Cataloguing in Publication Data</i><br/><br/>
A CIP data record for this title is available from the British Library</p>
<p class="copyright3">ISBN: 978-1-84832-104-5<br/>
PDF ISBN: 978-1-78346-503-3<br/>
EPUB ISBN: 978-1-78346-969-7<br/>
PRC ISBN: 978-1-78346-736-5</p>
<p class="copyright3">All rights reserved. No part of this publication may be reproduced<br/>
or transmitted in any form or by any means, electronic or mechanical,<br/>
including photocopying, recording, or any information storage<br/>
and retrieval system, without either prior permission in writing<br/>
from the publisher or a licence permitting restricted copying.</p>
<p class="copyright3">Typeset and designed by Stephen Dent</p>
<p class="copyright3">Printed and bound in China via Printworks International</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?2625cec6